import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

interface BackButtonProps {
  to?: string;
  label?: string;
  className?: string;
}

export default function BackButton({ to = '/settings', label, className = '' }: BackButtonProps) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white mb-6 transition-colors ${className}`}
    >
      <ArrowLeftIcon className="h-5 w-5 mr-2" />
      {label || (to === '/settings' ? t('backToSettings') : t('buttons.back'))}
    </button>
  );
}
